import api from './api';
import { ColorCollectionModel, CreateColorCollectionModelData, UpdateColorCollectionModelData } from '../types/colorCollectionModel';

export const colorCollectionModelService = {
  // Get all models for a color collection
  getByColorCollection: async (
    workspaceId: string,
    colorCollectionId: string,
    page?: number,
    limit?: number,
    search?: string
  ) => {
    const params: any = {};
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;
    if (search) params.search = search;

    const response = await api.get(
      `/workspaces/${workspaceId}/pkg-color-collections/${colorCollectionId}/models`,
      { params }
    );
    return response.data;
  },

  // Add a model to a color collection
  create: async (
    workspaceId: string,
    colorCollectionId: string,
    data: CreateColorCollectionModelData
  ) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/pkg-color-collections/${colorCollectionId}/models`,
      data
    );
    return response.data;
  },

  // Add multiple models to a color collection
  createMultiple: async (
    workspaceId: string,
    colorCollectionId: string,
    models: CreateColorCollectionModelData[]
  ) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/pkg-color-collections/${colorCollectionId}/models/bulk`,
      { models }
    );
    return response.data;
  },

  // Update a model in a color collection
  update: async (
    workspaceId: string,
    colorCollectionId: string,
    modelId: string,
    data: UpdateColorCollectionModelData
  ) => {
    const response = await api.put(
      `/workspaces/${workspaceId}/pkg-color-collections/${colorCollectionId}/models/${modelId}`,
      data
    );
    return response.data;
  },

  // Update multiple models in a color collection
  updateMultiple: async (
    workspaceId: string,
    colorCollectionId: string,
    models: UpdateColorCollectionModelData[]
  ) => {
    const response = await api.put(
      `/workspaces/${workspaceId}/pkg-color-collections/${colorCollectionId}/models/bulk`,
      { models }
    );
    return response.data;
  },

  // Remove a model from a color collection
  delete: async (
    workspaceId: string,
    colorCollectionId: string,
    modelId: string
  ) => {
    const response = await api.delete(
      `/workspaces/${workspaceId}/pkg-color-collections/${colorCollectionId}/models/${modelId}`
    );
    return response.data;
  }
};
